module.exports = __webpack_public_path__ + "src/assets/static/img/playmarket.1ee4c8f4.svg";